<template>
  <modal ref="modal">
    <modal-body :message="message" />
    <modal-footer>
      <delete-button @click="doDelete" />
      <cancel-button data-coreui-dismiss="modal" />
    </modal-footer>
  </modal>
</template>

<script>
import Modal from "@/views/atoms/Modal";
import ModalBody from "@/views/atoms/ModalBody";
import ModalFooter from "@/views/atoms/ModalFooter";
import DeleteButton from '@/views/molecules/buttons/DeleteButton';
import CancelButton from '@/views/molecules/buttons/CancelButton';

export default {
  name: "DeleteConfirmModal",
  components: {
    Modal,
    ModalBody,
    ModalFooter,
    DeleteButton,
    CancelButton,
  },
  props: {
    message: {
      type: String,
      default: "削除してよろしいですか？",
    },
  },
  emits: ['delete'],
  methods: {
    show() {
      this.$refs.modal.show();
    },
    doDelete() {
      this.$refs.modal.hide();
      this.$emit('delete');
    },
  },
}
</script>
